import { render, staticRenderFns } from "./singleAdministrationChildrenFirstOldEdit.vue?vue&type=template&id=8d47af42"
import script from "./singleAdministrationChildrenFirstOldEdit.vue?vue&type=script&lang=js"
export * from "./singleAdministrationChildrenFirstOldEdit.vue?vue&type=script&lang=js"
import style0 from "./singleAdministrationChildrenFirstOldEdit.vue?vue&type=style&index=0&id=8d47af42&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports